import React, { Component } from 'react';
import { Platform, View, Text} from 'react-native'
import { JDText, JDImage, JDDevice, MapView, JDTouchable } from '@jdreact/jdreact-core-lib'
import PropTypes from "prop-types"
import { getPointList } from '../../utils/api'
import styles from './styles'
import locationImg from './assets/location.png';
import bus from './assets/bus3.png'
import subway from './assets/subway3.png'
import hospital from './assets/hospital3.png'
import school from './assets/school3.png'
import shop from './assets/shooping3.png'
import bank from './assets/bank3.png'
import LoadingGif from './assets/loading.gif'

const LATITUDE_DELTA = 0.00900901;
const LONGITUDE_DELTA = 0.00900901;

export default class MapWeb extends Component {
  static propTypes = {
    addressLat: PropTypes.number,	// 纬度
    addressLon: PropTypes.number,	// 经度
    plotName: PropTypes.string,	// 点位名称
    plotAddress: PropTypes.string,	// 地址
    provider: PropTypes.any,	// provider
    hasPoint: PropTypes.bool, // 是否有周边列表
    onMapPress: PropTypes.func,	// 地图点击事件
    pageShowMap: PropTypes.bool, // 是否可以请求地图周边服务（曝光）
  }

  state = {
    // 导航栏
    tabListInfo: [
      {
        icon: bus,
        name: '公交',
        range: 3000,  // 范围
        pointList:null
      },
      {
        icon: subway,
        name: '地铁',
        range: 3000,
        pointList:null
      },
      {
        icon: hospital,
        name: '医院',
        range: 3000,
        pointList:null
      },
      {
        icon: school,
        name: '学校',
        range: 3000,
        pointList:null
      },
      {
        icon: shop,
        name: '商场',
        range: 3000,
        pointList:null
      },
      {
        icon: bank,
        name: '银行',
        range: 3000,
        pointList:null
      },
    ],
    isPoiLoading:false, // 资源是否正在请求
    selectTab: 0, // 选中tab
    pointList: [], // 点位列表
    isLoadPoint: false
  }

  componentWillReceiveProps(nextProps) {
    if(!this.state.isLoadPoint && nextProps.pageShowMap) {
			this.getResourcesByName({ index: 0, searchname: '公交' })
	  }
  }

  // tab切换
  tabClick = (item, index) => {
    this.setState({
      selectTab: index
    })
    const { tabListInfo } = this.state
    if( !!tabListInfo[index].pointList ) return 
    this.getResourcesByName({ index, searchname: item.name })
  }
  // 初始化地图
  getResourcesByName = async (searchItem) => {
    const { tabListInfo } = this.state
    const { index, searchname } = searchItem	// 搜索 项
    const page_size = 10
    const page_index = 1
    const keyword = encodeURI(searchname)
    let { addressLat, addressLon } = this.props
    if (addressLat || addressLon) {
      this.setState({isPoiLoading:true, isLoadPoint: true })
      try {
        const params = {
          boundary:`nearby(${addressLat},${addressLon},1000)`,
          keyword:keyword,
          pageSize:page_size,
          pageIndex:page_index,
        }
        const res = await getPointList(params)  // 周边检索
        if (res.status === 0) {
          // 判断距离是否 超过 范围
          const rangeData = res.data.sort((a,b)=>a._distance-b._distance).filter(item => item._distance <= tabListInfo[index].range).slice(0,3)  // 获取范围内的结果
          this.setState({
            tabListInfo: tabListInfo.map((item,i)=> i === index ? {...item, pointList:rangeData}: item)
          })
        } else {
          this.setState({
            tabListInfo: tabListInfo.map((item,i)=> i === index ? {...item, pointList:null}: item)
          })
        }
      } catch (error) {
        this.setState({
          tabListInfo: tabListInfo.map((item,i)=> i === index ? {...item, pointList:null}: item)
        })
      } finally{
        this.setState({isPoiLoading:false})
      }
    }
  }
  render() {
    let {
      addressLat,
      addressLon,
      provider,
      hasPoint,
      plotName,
      plotAddress,
      onMapPress
    } = this.props;
    const { tabListInfo, selectTab, isPoiLoading } = this.state

    const renderMapPoint = () => {
      const currentTab = tabListInfo[selectTab].pointList     // 当前选中
      const isEmpty = (!currentTab || ( Array.isArray(currentTab) && currentTab.length === 0))
      const currentListDom = isPoiLoading ? 
				<View style={styles.pointListEmpey}>
					<JDImage source={LoadingGif} style={styles.pointListLoadingIcon}/>
					<JDText style={styles.pointListEmpeyMessage} >在来的路上了～～</JDText>
				</View> : isEmpty ? <View style={styles.pointListEmpey}>
            <JDImage source={{ uri: 'https://img12.360buyimg.com/imagetools/jfs/t1/167372/29/4669/3612/6013d61cE2a7cc22c/5636f036d5bda28e.png' }} style={styles.pointListEmpeyIcon} />
            <JDText style={styles.pointListEmpeyMessage}>抱歉，暂未查询到{tabListInfo[selectTab].name}数据</JDText>
          </View> : <View style={styles.mapResourceList}>
            {
              currentTab.map((item, index) => {
                // 处理距离
                const buildDist = (num) => {
                  if (num < 1000) return parseInt(num);
                  num = num * 100;
                  const result = num / 100000;
                  return Math.floor(result * 10) / 10 + "k";
                }
                return <View key={index} style={styles.mapResourceItem} >
                  <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <JDImage source={tabListInfo[selectTab].icon} style={styles.mapResourceImg} />
                    <JDText style={{ ...styles.mapResourceName }} numberOfLines={1}>{item.title}</JDText>
                  </View>
                  <JDText style={styles.mapResourceDist}>直线{buildDist(item._distance)}m</JDText>
                </View>
              })
            }
          </View>
      return <View style={styles.mapResourceBox}>
        <View style={styles.mapNavList}>
          {
            tabListInfo.map((item, index) => {
              const isSelected = selectTab === index
              return <JDTouchable key={index} onPress={() => this.tabClick(item, index)}>
                <View style={[styles.mapNavItem, isSelected ? { backgroundColor: '#FEE7E4' } : '']} >
                  <JDText style={[{ textAlign: 'center', fontSize: JDDevice.getRpx(26), }, isSelected ? { fontWeight: 'bold', color: 'rgba(250,44,25,1)' } : '']}>{item.name}</JDText>
                </View>
              </JDTouchable>
            })
          }
        </View>
        <View style={styles.mapResourceList}>{ currentListDom }</View>
      </View >
    }
    return <View style={{ ...styles.mapAndResourceBox }}>
      {/* 地图 */}
      < View style={styles.map} >
        <MapView
          provider={provider}
          style={styles.map}
          mapType={MapView.MAP_TYPES.STANDARD}
          initialRegion={{
            latitude: addressLat + 0.001,
            longitude: addressLon,
            latitudeDelta: LATITUDE_DELTA,
            longitudeDelta: LONGITUDE_DELTA,
          }}
          // 添加地图点击事件
          onPress={() => {
            if (onMapPress && typeof onMapPress === 'function') {
              onMapPress()
            }
          }}
        >
          <MapView.Marker
            ref={ref => { this.markRef = ref }}
            coordinate={{
              latitude: addressLat,
              longitude: addressLon,
            }}
            image={locationImg}
            style={styles.marker}
          >
            {/* 弹窗 */}
            {Platform.OS == 'ios' &&
              <View style={styles.textMarkerBox}>
                <View style={styles.textMarkerContanier}>
                  <JDText style={styles.markerTitle} numberOfLines={1}>{plotName}</JDText>
                  <JDText style={styles.markerDescription} numberOfLines={1}>{plotAddress}</JDText>
                </View>
                <View style={styles.textMarkerArrow}></View>
              </View>}
          </MapView.Marker>
        </MapView>
      </View>
      {/* 周边资源列表 */}
      <View style={{ paddingVertical: JDDevice.getRpx(1) }}>{hasPoint && renderMapPoint()}</View>
    </View >
  }
}